// extracted by mini-css-extract-plugin
export default {"FolderListItemIcon":"FolderListItem_FolderListItemIcon__m-vn2"};